import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './LoanHistory.css';
import { ProfilePreviewWrapper } from "../Dashboard/ProfilePage/style";
import ProfileHeader from "../Dashboard/ProfilePage/ProfileHeader";
import { allLeads, getDashboardData } from "../../Utils/api";
import { getStorage, setStorage } from "../../Utils/common";
import {
  CalendarDays,
  IndianRupee,
  FileText,
  ChevronRight,
} from "lucide-react";


function LoanHistory() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setStorage("pancard", dashboardData?.Data?.profile_details?.pancard);
        const params1 = {
          pancard: getStorage("pancard")
        };
        allLeads(params1).then((resp) => {
          if (resp?.data?.Status === 1) {
            const LeadData = resp?.data?.Data?.lead_list;
            setLeads(LeadData);
          }
        }).catch(error => {
          console.error("Error fetching leads:", error);
        });
      }
    });
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleCardClick = (leadId) => {
    navigate("/my-dashboard/details", { state: { leadId } });
  };

  return (
    <ProfilePreviewWrapper>
      <ProfileHeader />
      {/* <div className="loan-history">
        {leads.length > 0 ? (
          leads.map(lead => (
            <div
              key={lead.lead_id}
              className="lead-card"
              onClick={() => handleCardClick(lead.lead_id)}
            >
              <h3>Lead id: {lead.lead_id}</h3>
              <p>Loan Amount: {lead.loan_amount}</p>
              <p>Status: {lead.status}</p>
              <p>Applied Date: {formatDate(lead.lead_entry_date)}</p>
            </div>
          ))
        ) : (
          <p style={{ color: "#1D3557" }}>No loan history found.</p>
        )}
      </div> */}

      <div className="mt-8">
        {leads.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
            {leads.map((lead) => (
              <div
                key={lead.lead_id}
                onClick={() => handleCardClick(lead.lead_id)}
                className="group bg-white rounded-3xl border border-gray-200 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer overflow-hidden"
              >
                {/* Header */}
                <div className="flex items-center justify-between p-5 border-b border-gray-100">

                  <div>
                    <p className="text-xs text-gray-500 uppercase tracking-wide">
                      Application
                    </p>

                    <h3 className="text-xl font-bold text-[#2D5F7A]">
                      #{lead.lead_id}
                    </h3>
                  </div>

                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold
                ${lead.status?.toLowerCase() === "approved"
                        ? "bg-green-100 text-green-700"
                        : lead.status?.toLowerCase() === "pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : lead.status?.toLowerCase() === "rejected"
                            ? "bg-red-100 text-red-700"
                            : "bg-blue-100 text-[#173A7A]"
                      }
              `}
                  >
                    {lead.status || "NA"}
                  </span>

                </div>

                {/* Body */}
                <div className="p-5 space-y-5">

                  <div className="flex items-center justify-between">

                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
                        <IndianRupee className="w-5 h-5 text-[#173A7A]" />
                      </div>

                      <div>
                        <p className="text-xs text-gray-500">
                          Loan Amount
                        </p>

                        <p className="font-semibold text-[#173A7A]">
                          ₹{lead.loan_amount || "0"}
                        </p>
                      </div>
                    </div>

                  </div>

                  <div className="border-t border-gray-100 pt-5 flex items-center justify-between">

                    <div className="flex items-center gap-3">

                      <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center">
                        <CalendarDays className="w-5 h-5 text-orange-500" />
                      </div>

                      <div>
                        <p className="text-xs text-gray-500">
                          Applied Date
                        </p>

                        <p className="font-semibold text-[#173A7A]">
                          {formatDate(lead.lead_entry_date)}
                        </p>
                      </div>

                    </div>

                  </div>

                </div>

                {/* Footer */}
                <div className="px-5 pb-5">

                  <button className="w-full flex items-center justify-center gap-2 rounded-xl bg-[#2D5F7A] py-3 text-white font-medium transition-all duration-300 ">

                    <FileText className="w-5 h-5" />

                    View Details

                    <ChevronRight className="w-4 h-4" />

                  </button>

                </div>

              </div>
            ))}
          </div>
        ) : (
          <div className="rounded-3xl border border-dashed border-gray-300 bg-white p-12 text-center">

            <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-gray-100">
              <FileText className="w-10 h-10 text-gray-400" />
            </div>

            <h3 className="text-xl font-semibold text-[#173A7A]">
              No Loan History
            </h3>

            <p className="mt-2 text-gray-500">
              You haven't applied for any loans yet.
            </p>

          </div>
        )}
      </div>

    </ProfilePreviewWrapper>
  );
}

export default LoanHistory;